import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getRef } from '../affiliateService'

export const useAffiliateRef = (refNum?: string) => {
  const { data: loggedUser } = useCurrentUser()
  const refNumber = refNum || loggedUser?.UserAttributes?.['custom:refNum']

  return useQuery({
    queryKey: [QUERY_KEYS.AFFILIATE, 'ref', refNumber],
    queryFn: () => getRef(refNumber!),
    enabled: !!refNumber,
  })
}
